module.exports = __webpack_public_path__ + "static/media/logo2-fr.51a9af1d.png";